// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46106fb1","453":"0554d5a9","455":"171ad3db","977":"dbdfe440"}[chunkId] + ".chunk.js";
};